import { toast } from "react-toastify";
import { track } from "./track";

const MAX_TEXT = 80;
const REPEAT_MS = 1000;

const readText = (content) => {
  if (typeof content !== "string" && typeof content !== "number") return undefined;
  return String(content).replace(/\s+/g, " ").trim().slice(0, MAX_TEXT) || undefined;
};

export const watchResults = () => {
  if (!toast || typeof toast.onChange !== "function") return () => {};
  let last = { key: "", at: 0 };
  return toast.onChange((item) => {
    if (!item || item.status !== "added") return;
    const kind = item.type || "default";
    const text = readText(item.content);
    const key = `${kind}|${text}`;
    const at = Date.now();
    const repeated = last.key === key && at - last.at < REPEAT_MS;
    last = { key, at };
    if (!repeated) track("result", kind, "shown", text);
  });
};

export default watchResults;
